module.exports={
  "hover": "Hover",
  "click": "Click",
  "mapPositions": "Map positions",
  "yourLocation": "Your location",
  "zoom": "Zoom",
  "saveCurrentMapPosition": "Save current map position",
  "locating": "Locating...",
  "hideYourPositionMarkerFromTheMap": "Hide your position marker from the map",
  "geolocationIsNotSupportedByThisBrowser": "Geolocation is not supported by this browser.",
  "latitude": "Latitude",
  "longitude": "Longitude",
  "zoomIn": "Zoom in",
  "zoomOut": "Zoom out",
  "showInsightPanel": "Show insight panel",
  "focusOnMap": "Focus on map",
  "exitFocusOnMap": "Exit focus on map",
  "centerMapOnLayer": "Center map on layer",
  "aspectRatio": "Aspect ratio",
  "mapSelection": "Show results on map:",
  "mapSelectionLeft": "Left",
  "mapSelectionRight": "Right",
  "distance": "Distance",
  "layers": "Layers",
  "parcelTitle": "Parcel",
  "parcelId": "Parcel ID",
  "parcelOwner": "Owner",
  "parcelAddress": "Address",
  "parcelLandUse": "Land use",
  "parcelAcres": "Acres",
  "parcelSource": "Source: {source}",
  "parcelLoading": "Loading parcel…",
  "parcelUnavailable": "Parcel details are unavailable right now.",
  "parcelNotFound": "No parcel found at this point.",
  "parcelNotCovered": "Parcel details aren't available in {state} yet.",
  "parcelNotCoveredHere": "Parcel details aren't available here."
}
